import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { useItineraryServiceWithContext } from '@services/itinerary';
import { logError } from "@services/log-service";

export const fetchBodyData = createAsyncThunk(
  'bodyData/fetchBodyData',
  async (data, { rejectWithValue }) => {
    try {
      const { getBodyData } = useItineraryServiceWithContext(data.domain);
      const response = await getBodyData(data.id);
      return response;
    } catch (error) {
      logError(error, {
        location: "getBodyData",
      })
      return rejectWithValue(error);
    }
  }
);

const bodyDataSlice = createSlice({
  name: "bodyData",
  initialState: {
    data: null,
  },
  reducers: {
    setBodyData: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBodyData.fulfilled, (state, action) => {
        state.data = action.payload;
      })
      .addCase(fetchBodyData.rejected, (state, action) => {
        state.error = action.payload || action.error;
      });
  },
});

export const { setBodyData } = bodyDataSlice.actions;
export default bodyDataSlice.reducer;
